import { RichBlockFormatType, RichTextFormatType } from "components/rich-editor/plugins/richText";
import { EventPlace, trackEngagement } from "helpers/analytics";

export const trackTextFormattingClick = (format: RichTextFormatType | RichBlockFormatType | "link"): void => {
  trackEngagement("Editor: text formatting used", EventPlace.RichTextEditor, { type: format });
};
